<template>
	<LayoutBase>
		<header id="content__header">
			<div class="company-info">
				<img
                    class="flag"
                    :src="resource.country.flag"
                    alt="test"
                    v-if="resource.member"
                    v-tippy="resource.country.name"
                />
				<h1>{{ resource.companyName ? resource.companyName : resource.projectName }}</h1>
			</div>

			<router-link :to="{ name: 'madd-preview', params: { madd_id: resource.id }}" class="btn btn--primary"
			             v-if="resource.can.edit">Edit
			</router-link>
		</header>
		<section class="company-info">
			<ul class="grid post-details">
				<li v-if="resource.createdAt" class="col-12 col-md-3 detail">
					<span class="label">Completed Date</span>
					<span class="h3"><SvgIcon :icon="'calendar'" /> {{ resource.completedAt }}</span>
				</li>
				<li v-if="resource.location" class="col-12 col-md-3 detail">
					<span class="label">Location of Activities</span>
					<span class="h3"><SvgIcon :icon="'location'" /> {{ resource.location }}</span>
				</li>
				<li v-if="resource.dealType" class="col-12 col-md-3 detail">
					<span class="label">Deal Type</span>
					<span class="h3"><SvgIcon :icon="'deal'" /> {{ resource.dealType }}</span>
				</li>
				<li v-if="resource.counterpartCompany" class="col-12 col-md-3 detail">
					<span class="label">Counterpart Company</span>
					<span class="h3"><SvgIcon :icon="'company'" /> {{ resource.counterpartCompany }}</span>
				</li>
			</ul>

			<hr>

			<ul class="grid post-details">
				<li v-if="resource.transactionCurrency" class="col-12 col-md-3 detail">
					<span class="label">Currency</span>
					<strong><SvgIcon :icon="'money'" /> {{ resource.transactionCurrency }}</strong>
				</li>
				<li v-if="resource.transactionValue" class="col-12 col-md-3 detail">
					<span class="label">Transaction Value</span>
					<strong><SvgIcon :icon="'value'" /><span v-if="resource.transactionCurrency">{{ resource.transactionCurrency }}</span> {{ resource.transactionValue }}m</strong>
				</li>
				<li v-if="resource.primarySector" class="col-12 col-md-3 detail">
					<span class="label">Main Sector</span>
					<span class="sector">{{ resource.primarySector.name }}</span>
				</li>
				<li v-if="resource.sectors" class="col-12 col-md-6 detail">
					<span class="label">Sectors</span>
					<span class="sector" v-for="sector in resource.sectors">{{ sector.name }}</span>
				</li>
			</ul>
		</section>

		<hr>

		<Accordion :items="formatAccordionData()" :start-open="true"></Accordion>

		<section class="grid">
			<div class="col-12 col-md-8">
				<div class="card" v-if="resource.differenceMade">
					<div class="header">Value added to the project</div>
					<div v-html="resource.differenceMade"></div>
				</div>

				<div class="card" v-if="resource.testimonial">
					<div class="header">Testimonial</div>
					<div v-html="resource.testimonial"></div>
				</div>
			</div>
			<div class="col-12 col-md-4">
                <MemberCard v-if="resource.member" :member="resource.member"></MemberCard>

				<div v-if="resource.lead" class="profile-list">
					<p class="profile-list__title">Lead User</p>

					<UserCard :user="resource.lead" :borderless="true"></UserCard>
				</div>
				<div v-if="filterLead(resource.team).length" class="profile-list">
					<p class="profile-list__title">Users also involved</p>

					<UserCard :user="profile" :borderless="true" :small="true"
					          v-for="profile in filterLead(resource.team)" :key="profile.id">
					</UserCard>
				</div>
			</div>
		</section>
	</LayoutBase>
</template>

<script>
	import LayoutBase from '../Layout/LayoutBase';
	import Response from '../Partials/Response';
	import API from '../../api';
	import SvgIcon from '../SvgIcon';
	import Accordion from '../lib/Accordion';
	import ResourceView from '../ResourceView';
	import UserCard from '../User/UserCard';
	import MemberCard from '../Member/MemberCard';

	export default {
		name: 'MADDView',
		mixins: [ResourceView],
		components: {
			MemberCard,
			UserCard,
			Accordion,
			LayoutBase,
			Response,
			SvgIcon
		},
		data() {
			return {
				resource: {
					sectors: null,
					team: [],
				},
			}
		},
        watch: {
            id: function (newVal, oldVal) {
                return API.getMADD(newVal).then(response => {
                    console.log("[MADDView.vue] - ", response);
                    this.resource = response;
                });
            }
        },
		methods: {
			fetchResource() {
                return API.getMADD(this.id);
            },
			formatAccordionData() {
				let items = [];

				if(!this.resource) return items;

				if(this.resource.activity){
                    items.push({ title : 'Company bio', content : this.resource.activity });
                }

				if(this.resource.dealSummary){
					items.push({ title : 'Deal Summary', content : this.resource.dealSummary });
				}

                if(this.resource.tombstone){
                    items.push({ title : 'Tombstone Company Description', content : this.resource.tombstone });
                }

				return items;
			},
			filterLead(users) {
				return users.filter(user => {
					return user.id !== this.resource.lead.id;
				});
			},
		}
	}
</script>

<style lang="scss" scoped>
	#content {
		#content__header {
			justify-content: space-between;
		}
	}
	.accordion{
		margin: 3rem 0;
	}

	.card + .card{
		margin-top: 2rem;
	}
</style>
